/* ============================================================
   FLY TO CART ANIMATION + BUTTON STATE — oud-shop.com (HDT Theme)
   A2Z Solutions Custom Snippet — نسخة v3
   ============================================================
   التعديلات الجديدة:
   1. الصورة الطايرة تبدأ من زرار Add to cart نفسه (مش من صورة المنتج)
   2. الزرار يتحول لعلامة ✓ Added لثانيتين، ثم يرجع لحالته الأصلية
   ============================================================ */

(function () {
  'use strict';

  // ---------- CONFIG ----------
  var CART_ICON_SELECTOR = '.hdt-site-nav_cart';
  var ADD_BUTTON_SELECTOR = 'button[name="add"]';
  var PRODUCT_IMAGE_SELECTOR = '.hdt-card-product__media--main, .hdt-product-gallery img, img[src*="cdn/shop/files"]';

  var FLY_DURATION = 1000;       // سرعة طيران الصورة (مللي ثانية)
  var FLY_IMAGE_SIZE = 20;      // حجم الصورة وهي طايرة (بكسل)
  var FLY_END_OPACITY = '0.5';    // شفافية الصورة وهي قاربة توصل الكارت (1 = واضحة 100% طول الرحلة)
  var SUCCESS_DURATION = 2000;  // مدة ظهور علامة الصح قبل الرجوع (مللي ثانية)
  var CURVE_HEIGHT = 150;       // ارتفاع الانحناء فوق الخط المباشر (بكسل) — كبّرها لقوس أعلى، صغّرها لقوس أهدأ
  var CURVE_BIAS = 0.5;         // موضع قمة القوس بين الزرار (0) والكارت (1) — 0.5 = نص المسافة بالظبط

  function getCartIcon() {
    return document.querySelector(CART_ICON_SELECTOR);
  }

  function getProductImage() {
    var mainImg = document.querySelector('.hdt-product-single__media img, .hdt-product-gallery__item img, .hdt-product-media img');
    if (mainImg) return mainImg;
    return document.querySelector(PRODUCT_IMAGE_SELECTOR);
  }

  // ---------- الأنيميشن: يبدأ من موقع الزرار نفسه، بمسار منحني ----------
  function flyToCart(button) {
    var cartIcon = getCartIcon();
    var sourceImg = getProductImage();
    if (!cartIcon || !sourceImg || !button) return;

    var btnRect = button.getBoundingClientRect();
    var cartRect = cartIcon.getBoundingClientRect();

    var flyer = sourceImg.cloneNode(true);
    flyer.style.position = 'fixed';
    flyer.style.zIndex = '99999';
    flyer.style.borderRadius = '8px';
    flyer.style.objectFit = 'cover';
    flyer.style.pointerEvents = 'none';
    flyer.style.margin = '0';
    flyer.style.boxShadow = '0 4px 12px rgba(0,0,0,0.25)';
    flyer.style.willChange = 'transform, opacity, width, height';
    // ملحوظة: لا transition هنا — الحركة كلها هتتحسب فريم بفريم بالـ JS تحت

    // نقطة البداية والنهاية (مركز كل عنصر)
    var startSize = 50;
    var startX = btnRect.left + btnRect.width / 2;
    var startY = btnRect.top + btnRect.height / 2;
    var endX = cartRect.left + cartRect.width / 2;
    var endY = cartRect.top + cartRect.height / 2;

    // نقطة التحكم (Control point) فوق الخط المباشر بين البداية والنهاية
    // CURVE_BIAS تحدد مكانها أفقيًا: قريبة من الزرار (قيمة صغيرة) أو قريبة من الكارت (قيمة كبيرة)
    var controlX = startX + (endX - startX) * CURVE_BIAS;
    var controlY = Math.min(startY, endY) - CURVE_HEIGHT;

    flyer.style.width = startSize + 'px';
    flyer.style.height = startSize + 'px';
    flyer.style.left = (startX - startSize / 2) + 'px';
    flyer.style.top = (startY - startSize / 2) + 'px';
    flyer.style.opacity = '1';

    document.body.appendChild(flyer);

    var startTime = null;
    var startOpacity = 1;
    var endOpacity = parseFloat(FLY_END_OPACITY);

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var elapsed = timestamp - startTime;
      var t = Math.min(elapsed / FLY_DURATION, 1);
      var eased = easeInOutQuad(t);

      // معادلة Quadratic Bezier: نقطة على المسار المنحني عند النسبة eased
      var oneMinusT = 1 - eased;
      var curX = oneMinusT * oneMinusT * startX + 2 * oneMinusT * eased * controlX + eased * eased * endX;
      var curY = oneMinusT * oneMinusT * startY + 2 * oneMinusT * eased * controlY + eased * eased * endY;

      // الحجم يصغر تدريجيًا من startSize إلى FLY_IMAGE_SIZE
      var curSize = startSize + (FLY_IMAGE_SIZE - startSize) * eased;
      // الشفافية تتدرج من startOpacity إلى endOpacity
      var curOpacity = startOpacity + (endOpacity - startOpacity) * eased;
      // دوران خفيف تدريجي
      var curRotate = 15 * eased;

      flyer.style.left = (curX - curSize / 2) + 'px';
      flyer.style.top = (curY - curSize / 2) + 'px';
      flyer.style.width = curSize + 'px';
      flyer.style.height = curSize + 'px';
      flyer.style.opacity = curOpacity;
      flyer.style.transform = 'rotate(' + curRotate + 'deg)';

      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        flyer.remove();
        bounceCartIcon(cartIcon);
      }
    }

    requestAnimationFrame(step);
  }

  function bounceCartIcon(cartIcon) {
    cartIcon.style.transition = 'transform 280ms cubic-bezier(0.34, 1.56, 0.64, 1)';
    cartIcon.style.transform = 'scale(1.25)';
    setTimeout(function () {
      cartIcon.style.transform = 'scale(1)';
    }, 280);
  }

  // ---------- تغيير حالة الزرار: نص + علامة صح ----------
  function setButtonSuccess(button) {
    if (!button || button.dataset.flyAnimating === 'true') return;
    button.dataset.flyAnimating = 'true';

    // نخزن المحتوى الأصلي للزرار لو لسه ماخزناه
    if (!button.dataset.originalHtml) {
      button.dataset.originalHtml = button.innerHTML;
    }

    var originalHtml = button.dataset.originalHtml;

    // نحط علامة الصح + كلمة Added
    button.innerHTML =
      '<span style="display:inline-flex;align-items:center;justify-content:center;gap:6px;">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
      'Added' +
      '</span>';

    button.disabled = true;
    button.style.transition = 'background-color 200ms ease';

    setTimeout(function () {
      button.innerHTML = originalHtml;
      button.disabled = false;
      delete button.dataset.flyAnimating;
    }, SUCCESS_DURATION);
  }

  // ---------- الربط الرئيسي ----------
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

    var button = form.querySelector(ADD_BUTTON_SELECTOR);
    if (!button) return;

    flyToCart(button);
    setButtonSuccess(button);
  }, true);

})();